import React from "react";
import { GeoJSON, Marker, Popup } from "react-leaflet";
import { Button } from "@material-ui/core";
import L from "leaflet";
import { NavLink } from "react-router-dom";
import iconUrl from "../image/pin24.png";
import schoolPrivateIconUrl from "../image/marker/school/school-private.png";
import schoolCommunityIconUrl from "../image/marker/school/school-community.png";
import educationUrl from "../image/education.png";
import officeUrl from "../image/office.png";
import industriesUrl from "../image/industries.png";
import infrastructureUrl from "../image/infrastructure.png";
import workshopUrl from "../image/workshop.png";
import agricultureUrl from "../image/agriculture.png";
import homestayUrl from "../image/homestay.png";
import economicUrl from "../image/economic.png";
import healthUrl from "../image/health.png";
import { BASE_URL, baseURLAPI } from "../../redux/axiosHandler";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { popup } from "../../variable/mapPointerPopup";

export default function GeoJsonLayer(props) {
  const selectedLanguage = "nepali";
  const institutePopUp = (properties) => {
    if (!properties.parentCategory) {
      const baseImageUrl = `${baseURLAPI}/imageUpload/image/${properties.id}_house.jpg`;
      return (
        <div>
          <img
            src={baseImageUrl}
            alt={properties.houseNumer}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "घर नम्बर" : "House Number"}
          </b>{" "}
          {properties.houseNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वार्ड नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "घरमुलीको नाम" : "Owner Name"}:
          </b>{" "}
          {properties.ownerName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "टोलको नाम" : "Owner Name"}
            Tole Name:
          </b>{" "}
          {properties.toleName}
          <br />
          {properties.contactNumber && (
            <span>
              <b>{selectedLanguage === "nepali" ? "सम्पर्क न" : "Contact"}:</b>{" "}
              {properties.contactNumber}
            </span>
          )}{" "}
          <br />
          <NavLink
            className="menu-link menu-toggle"
            to={`/home-survey/detail/${properties.id}`}
            target="_blank"
          >
            <Button variant="info">
              {selectedLanguage === "nepali"
                ? "विवरण हेर्नुहोस्"
                : "View Detail"}
            </Button>
          </NavLink>
        </div>
      );
    } else if (properties.name && properties.bankClass) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "बैंक वर्ग" : "Bank Class"}:
          </b>{" "}
          {properties.bankClass === 'a' ? "क बर्ग (वाणिज्य बैंक )" : properties.bankClass === 'b' ? "ख बर्ग (विकास बैंक )" : properties.bankClass === 'c' ? "ग वर्ग (वित्तिय सँस्था/ फाइनान्स )" : properties.bankClass === 'd' ? "घ वर्ग (लघु वित्त सँस्था)" : properties.bankClass === 'cooperative_pvt' ? "सहकारी सँस्था" : "विमा सँस्थान"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.bridgeType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "नदीको नाम" : "River Name"}:
          </b>{" "}
          {properties.riverName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "पुलको उचाइ" : "Bridge Height"}:
          </b>{" "}
          {properties.bridgeHeight}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "पुलको प्रकार" : "Bridge Type"}:
          </b>{" "}
          {properties.bridgeType === 'jholunge' ? "झोलुङ्गे" : properties.bridgeType === 'wood' ? "काठे" : properties.bridgeType === 'trust' ? "ट्रष्ट" : properties.bridgeType === 'rccc' ? "पक्की" : "अन्य"}
          <br />
          <b>{selectedLanguage === "nepali" ? "स्थिति" : "Status"}:</b>{" "}
          {properties.status === 'best' ? "राम्रो" : properties.status === 'good' ? "ठिकै" : "जिर्ण"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "मा स्थापित" : "Established At"}:
          </b>{" "}
          {properties.establishedAt}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.proprietorInfo) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "व्यापार प्रकार" : "Business Type"}
            :
          </b>{" "}
          {properties.businessType.map(value => {
            return value === 'kirana' ? "किराना /थोक /मार्ट  पसल, " : value === 'cloth_shop' ? "कपडा पसल  / फेन्सी स्टोर, " : value === 'hardware' ? "हार्डवेयर तथा निर्माण सामग्री व्यवसाय, " : value === 'cold_drinks' ? "चुरोट, मदिराजन्य , सुर्तीजन्य वस्तुहरुको व्यापार व्यवसाय, " : value === 'electronics' ? "इलेक्ट्रोनिक्स सामग्रीहरुको थोक तथा खुद्र व्यवसाय (मोबाइल ,कम्प्युटर ,एसी, टिभी,फ्रिज ,क्यामेरा पंखा लगायत सामग्री ), " : value === 'auto_mobile' ? "अटो मोबाइल्स (ट्याक्टर विक्री , कार जिप ,मोटर पार्ट्स ,मेसिनरी सामग्रीको सोरुम तथा व्यावसाय ), " : value === 'medicine_and_clinic' ? "औषधी पसल वा क्लिनिक  (डेन्टल क्लिनिक  सहित ), " : value === 'hotel_and_resturent' ? "होटेल तथा रेष्टुरेन्ट, रिसोर्ट , तारे होटल, खाजा घर  (चिया नास्ता पसल सहित ), " : value === 'jwellery_shop' ? "ज्वेलरी , सुन चादीका गरगहना पसल, " : value === 'consulting' ? "इलेक्ट्रिकल, वायारिङका सामग्रीहरुको थोक तथा  खुद्रा व्यावसाय, " : value === 'counseling' ? "परामार्श सेवा, अनुसन्धान तथा परामर्शदाता ,छापाखाना , प्रेस स्क्रिन , वृत्तचित्र निर्माण , सर्भेयर प्रिन्टर आदि व्यवसाय, " : value === 'mill' ? "कुटानी /पिसानी व्यवसाय, " : value === 'utensil' ? "भाडावर्तन, " : value === 'parlor' ? "पार्लर ,कस्मेटिक , बुटिक,सिलाई कटाई गर्ने व्यवसाय, " : value === 'meat_shop' ? "मासुजन्य पसल, " : value === 'vegitebale_and_fruits_sell_store_1' ? "तरकारी तथा फलफूल व्यवसाया, " : value === 'milk_dairy' ? "दुध डेरी तथा चिस्यान केन्द्र" : value === 'vetnary_shop' ? "भेटरीनरी पसल" : value === 'kewal_network' ? "केवल नेटवर्क /इन्टरनेट सेवा प्रदायक किकाय /कम्पनी" : value === 'jim' ? "शारीरिक व्यायामशाला (wellness center)" : value === 'football_play_ground_1' ? "फुटसल संचालन" : value === 'workshop' ? "वर्कशप" : value === 'party_palace' ? "पार्टी प्यालेस" : value === 'cold_drinks_and_sajawat_1' ? "कोल्ड ड्रिंक्स ,सिसा फ्रेमिङ, कार्पेट , सजावटका सामान , जनरल गुड्स आदि" : value === 'kawadi_pasal' ? "कवाडी पसल थोक तथा खुद्रा" : value === 'gas_diler' ? "ग्यास बिक्रि डिलर" : value === 'petrol_pump' ? "पेट्रोल पम्प" : value === 'tent_house' ? "टेन्टहाउस क्याटरिङ सेवा (भए नभएको दुवै )" : value === 'menpower' ? "वैदेशिक रोजगारमा पठाउँने सन्स्था , मेनपावर , विदेशको लागि जनशक्ति निर्यात गर्ने कम्पनी" : value === 'furnicher_shope' ? "फर्निचर पसल" : value === 'tution_center_1' ? "तालिम केन्द्र /  सिकाई केन्द्र" : value === 'housing_company' ? "घरजग्गा खरिद विक्री , हाउजिङ कम्पनी" : value === 'photo_studio' ? "कलर ल्याब /फोटो स्टुडियो" : value === 'arg_fam' ? "कृषि, पशु तथा माछा फर्म" : value === 'law_form' ? "कानून व्यवसाय तथा परामर्श" : value === 'colour_pasal' ? "पेन्ट्स / रङ्ग पसल तथा  व्यवसाय" : value === 'mall_pasal' ? "मल तथा विषादी व्यवसय" : value === 'stationary_pasal' ? "स्टेसनरी पसल" : value === 'godaam' ? "गोदाम" : "अन्य";
          })}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "बाटोको नाम" : "Street Name"}:
          </b>{" "}
          {properties.streetName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "स्थापना वर्ष"
              : "Established Year"}
            :
          </b>{" "}
          {properties.establishedYear}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.historyDetail) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "इतिहास विवरण" : "History Detail"}:
          </b>{" "}
          {properties.historyDetail}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.principalName) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "संस्थान प्रकार"
              : "Institute Type"}
            :
          </b>{" "}
          {properties.instituteType === 'private' ? "सँस्थागत (निजि)" : properties.instituteType === 'community' ? "सामुदायिक" : properties.instituteType === 'gumba' ? "गुम्बा" : properties.instituteType === 'veda' ? "वेद विद्याश्रम" : properties.instituteType === 'madrasa' ? "मदरसा" : properties.instituteType === 'university' ? "विश्वविद्यालय" : "क्याम्पस"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "संस्थान स्तर" : "Institute Level"}
            :
          </b>{" "}
          {properties.instituteLevel === 'private' ? "बाल विकास केन्द्र" : properties.instituteLevel === 'aadhaarbhut' ? "आधारभूत तह (१-५)" : properties.instituteLevel === 'primary_up_to_8' ? "आधारभूत तह (६ -८)" : properties.instituteLevel === 'maadhyamik' ? "माध्यमिक तह (९-१०)" : properties.instituteLevel === 'maadhyamik_next' ? "माध्यमिक तह (११ -१२)" : properties.instituteLevel === 'bachlors' ? "स्नातक तह" : properties.instituteLevel === 'masters' ? "स्नातकोत्तर तह" : "अन्य"}

          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "स्थापना वर्ष"
              : "Established Year"}
            :
          </b>{" "}
          {properties.establishedYear}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "प्रिन्सिपलको नाम"
              : "Principal Name"}
            :
          </b>{" "}
          {properties.principalName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "सम्पर्क नम्बर" : "Contact Number"}
            :
          </b>{" "}
          {properties.contactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.governmentOfficeType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "सरकारी कार्यालयको प्रकार"
              : "Government Office Type"}
            :
          </b>{" "}
          {properties.governmentOfficeType === 'tax_office' ? "कर कार्यालय" : properties.governmentOfficeType === 'forest_office' ? "वन कार्यालय" : properties.governmentOfficeType === 'dao' ? "जील्ला प्रशासन कार्यालय" : properties.governmentOfficeType === 'electricity' ? "विधुत प्राधिकरण कार्यालय": properties.governmentOfficeType === 'post_office' ? "हुलाक कार्यालय" : properties.governmentOfficeType === 'food_kyaarentaain' ? "खाध्य क्वारेन्टाइन " : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "कार्यालय प्रमुखको नाम"
              : "Office Head Name"}
            :
          </b>{" "}
          {properties.officeHeadName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "सूचना अधिकारी नाम"
              : "Information Officer Name"}
            :
          </b>{" "}
          {properties.informationOfficerName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "कार्यालय सम्पर्क"
              : "Office Contact"}
            :
          </b>{" "}
          {properties.officeContact}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.healthOrgType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "स्वास्थ्य संगठनको प्रकार"
              : "Health Organization Type"}
            :
          </b>{" "}
          {properties.healthOrgType === 'hospital' ? "अस्पताल" : properties.healthOrgType === 'healthPost' ? "स्वाथ्य चौकी" : properties.healthOrgType === 'swasthya_ikaai' ? "सामुदायिक स्वास्थ्य इकाई" : properties.healthOrgType === 'primary_heath_center' ? "प्राथमिक स्वास्थ्य  केन्द्र" : properties.healthOrgType === 'basic_health_center' ? "आधारभूत स्वास्थ्य सेवा केन्द्र" : properties.healthOrgType === 'urban_helath_center' ? "शहरी स्वास्थ्य केन्द्र" : properties.healthOrgType === 'village_clinic' ? "गाउँ घर क्लिनिक" : properties.healthOrgType === 'hiv_center_test' ? "एचआइभि परीक्षण तथा परामर्श केन्द्र" : properties.healthOrgType === 'maternity' ? "प्रसुती केन्द्र" : properties.healthOrgType === 'ayurved' ? "आयुर्वेद स्वास्थ्य केन्द्र" : properties.healthOrgType === 'natural_hospital' ? "प्राकृतिक चिकित्सालय" : properties.healthOrgType === 'eye_clinic' ? "आँखा उपचार केन्द्र" : properties.healthOrgType === 'child_hospital' ? "बाल अस्पताल" : properties.healthOrgType === 'blood_collect_center' ? "रक्त संचार केन्द्र" : properties.healthOrgType === 'education_hospital' ? "शिक्षण अस्पताल" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "संस्थान प्रकार"
              : "Institute Type"}
            :
          </b>{" "}
          {properties.instituteType === 'personal' ? "सँस्थागत (निजि )" : properties.instituteType === 'governmental' ? "सामुदायिक" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "प्रायोजकको नाम" : "Sponsor Name"}:
          </b>{" "}
          {properties.orgSponsorName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "सम्पर्क नम्बर" : "Contact Number"}
            :
          </b>{" "}
          {properties.orgContactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.historicalLegend) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "स्थापना मिति"
              : "Established Date"}
            :
          </b>{" "}
          {properties?.establishedDate}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "उप श्रेणी" : "Sub Category"}:
          </b>{" "}
          {properties.subCategory === 'temple' ? "मठमन्दिर" : properties.subCategory === 'mosque' ? "मस्जिद" : properties.subCategory === 'gumba' ? "गुम्बा" : properties.subCategory === 'dharmasala' ? "धर्मशाला" : properties.subCategory === 'museum' ? "संग्राहालय" : properties.subCategory === 'palace' ? "दरवार" : properties.subCategory === 'cultural_club' ? "साँस्कृतिक क्लब (नाचघर)" : properties.subCategory === 'charch' ? "चर्च" : properties.subCategory === 'saakela_thaan' ? "साकेला थान" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "ऐतिहासिक पौराणिक"
              : "Historical Legend"}
            :
          </b>{" "}
          {properties.historicalLegend}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "प्रायोजक व्यक्तिको नाम"
              : "Sponsor Person Name"}
            :
          </b>{" "}
          {properties.sponsorPersonInfo?.name}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "प्रायोजक व्यक्ति सम्पर्क नम्बर"
              : "Sponsor Person Contact Number"}
            :
          </b>{" "}
          {properties.sponsorPersonInfo?.contactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.productionGoodsName) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "उद्योग कोटि"
              : "Industry Category"}
            :
          </b>{" "}
          {properties.industryCategory === 'house_type_industries' ? "घरेलु उद्योग" : properties.industryCategory === 'medium_industries' ? "मझौला उद्योग" : properties.industryCategory === 'big_industries' ? "ठुला  उद्योग" : properties.industryCategory === 'laghu' ? "लघु" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "निर्देशक नाम" : "Director Name"}:
          </b>{" "}
          {properties.directorName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "उत्पादन सामानको नाम"
              : "Production Goods Name"}
            :
          </b>{" "}
          {properties.productionGoodsName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.institutionsType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "संस्थाको प्रकार"
              : "Institution Type"}
            :
          </b>{" "}
          {properties.institutionsType === 'ngo' ? "गैरसरकारी" : properties.institutionsType === 'ingo' ? "अन्तर्राष्ट्रिय  गैरसरकारी" : properties.institutionsType === 'private' ? "सँस्थागत  (निजि )" : properties.institutionsType === 'child_old_homeless' ? "बालगृह/बृद्धश्रम/ संचालित पुन:संस्थापना केन्द्रको" : properties.institutionsType === 'party_office_1' ? "राजनैतिक पार्टी  कार्यालय" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "कार्यालय प्रमुखको नाम"
              : "Office Head Name"}
            :
          </b>{" "}
          {properties.officeHeadName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "कार्यालय सम्पर्क"
              : "Office Contact"}
            :
          </b>{" "}
          {properties.officeContact}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.otherName) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "अर्को नाम" : "Other Name"}:
          </b>{" "}
          {properties.otherName}
          <br />
          <b>{selectedLanguage === "nepali" ? "विवरण" : "Description"}:</b>{" "}
          {properties.description}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.numberOfVisitor) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "पार्क विशेषता"
              : "Park Speciality"}
            :
          </b>{" "}
          {properties.parkSpeciality}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "पार्क विशेषता"
              : "Park Speciality"}
            :
          </b>{" "}
          {properties.numberOfVisitor}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.presidentName) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>{selectedLanguage === "nepali" ? "ठेगाना" : "Address"}:</b>{" "}
          {properties.address}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "अध्यक्षको नाम"
              : "President Name"}
            :
          </b>{" "}
          {properties.presidentName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "कार्यालय सम्पर्क नम्बर"
              : "Office Contact Number"}
            :
          </b>{" "}
          {properties.officeContactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.condition) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "राष्ट्रपति नाम"
              : "President Name"}
            :
          </b>{" "}
          {properties.presidentInfo.name}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "President Contact Number"
              : "अध्यक्ष सम्पर्क नम्बर"}
            :
          </b>{" "}
          {properties.presidentInfo.contactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.bankName) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.bankName}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.bankName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.streetName && properties.busStationName) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.streetName}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "बाटोको नाम" : "Street Name"}:
          </b>{" "}
          {properties.streetName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "बस स्टेशनको नाम"
              : "Bus Station Name"}
            :
          </b>{" "}
          {properties.busStationName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "उप श्रेणी" : "Sub Category"}:
          </b>{" "}
          {properties.subCategory === '2_whiller' ? "मोटरसाइकल /स्कुटर   (दुई पांग्रे )" : properties.subCategory === '4_whiller' ? "बस   (चार पांग्रे )" : properties.subCategory === 'safaari' ? "सफारी" : "अन्य"}
          {properties.subCategory}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.buildingUse) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "भवन स्वामित्व"
              : "Building Ownership"}
            :
          </b>{" "}
          {properties.buildingOwnership}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "भवन प्रयोग" : "Building Use"}:
          </b>{" "}
          {properties.buildingUse}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "राष्ट्रपति नाम"
              : "President Name"}
            :
          </b>{" "}
          {properties.presidentInfo.name}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "अध्यक्ष सम्पर्क नम्बर"
              : "President Contact Number"}
            :
          </b>{" "}
          {properties.presidentInfo.contactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.groupType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "समूह प्रकार" : "Group Type"}:
          </b>{" "}
          {properties.groupType === 'agri_group' ? "कृषक समूह" : properties.groupType === 'forest_group' ? "वन समूह" : properties.groupType === 'mother_group' ? "आमा समूह" : properties.groupType === 'bachat_group' ? "वचत समूह" : properties.groupType === 'tole_bikas_sanstha' ? "टोल बिकास सँस्था" : properties.groupType === 'paramparagat_group' ? "परमपरागत समूह" : properties.groupType === 'business_group' ? "उधमी समूह" : properties.groupType === 'child_club' ? "बाल क्लब (समूह )" : properties.groupType === 'youth_club' ? "युवा क्लब (समूह )" : properties.groupType === 'apaanga_club' ? "अपाङ्गता सञ्जाल समूह" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "अध्यक्ष नाम" : "chairman Name"}:
          </b>{" "}
          {properties.chairmanInfo.name}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "अध्यक्ष सम्पर्क नम्बर"
              : "chairman Contact Number"}
            :
          </b>{" "}
          {properties.chairmanInfo.contactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.electricSabhdaha) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>{selectedLanguage === "nepali" ? "ठेगाना" : "Address"}:</b>{" "}
          {properties.address}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "विद्युत सभा दहा"
              : "Electric Sabh Daha"}
            :
          </b>{" "}
          {properties.electricSabhdaha}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.culvertLength) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "उप श्रेणी" : "Sub Category"}:
          </b>{" "}
          कल्भर्ट
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "कल्भर्ट लम्बाइ"
              : "Culvert Length"}
            :
          </b>{" "}
          {properties.culvertLength}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.tankCapacity) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.wardNumber}
          <br />
          <b>{selectedLanguage === "nepali" ? "ठेगाना" : "Address"}:</b>{" "}
          {properties.address}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "स्रोत व्यक्ति सम्पर्क"
              : "Resource Person Contact"}
            :
          </b>{" "}
          {properties.resourcePersonContact}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.electricityType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "बिजुली प्रकार"
              : "Electricity Type"}
            :
          </b>{" "}
          {properties.electricityType === 'national_grid' ? "राष्ट्रियस्तरको  जलविधुत   योजना" : properties.electricityType === 'peltric' ? "पेल्ट्रिक सेट" : properties.electricityType === 'micro_hydro' ? "लघु जलविधुत" : properties.electricityType === 'solar_wind' ? "सोलार प्लान्ट/वायु" : "अन्य"}
          <br />
          <b>{selectedLanguage === "nepali" ? "क्षमता" : "Capacity"}:</b>{" "}
          {properties.capacity}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.newspaperType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "एफएम दायरा" : "FM Range"}:
          </b>{" "}
          {properties.fmRange}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "राष्ट्रपति नाम"
              : "President Name"}
            :
          </b>{" "}
          {properties.presidentInfo.name}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "अध्यक्ष सम्पर्क नम्बर"
              : "President Contact Number"}
            :
          </b>{" "}
          {properties.presidentInfo.contactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.address && properties.helper) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.address}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>{selectedLanguage === "nepali" ? "ठेगाना" : "Address"}:</b>{" "}
          {properties.address}
          <br />
          <b>{selectedLanguage === "nepali" ? "सहयोगी" : "Helper"} :</b>{" "}
          {properties.helper}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.ownership && properties.use) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.Ownership}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>{selectedLanguage === "nepali" ? "ठेगाना" : "Address"}:</b>{" "}
          {properties.address}
          <br />
          <b>{selectedLanguage === "nepali" ? "प्रयोग" : "use"}:</b>{" "}
          {properties.use}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "स्वामित्व" : "Ownership"}:
          </b>{" "}
          {properties.ownership === 'own' ? "निजि" : properties.ownership === 'rent' ? "भाडामा" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.areaAndCapacity) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.purpose) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "उप श्रेणी" : "Sub Category"}:
          </b>{" "}
          बाँध / कुलो / नहर
          <br />
          <b>
            {selectedLanguage === "nepali" ? "उद्देश्य" : "Purpose"}:
          </b>{" "}
          {properties.purpose === 'krishi' ? "कृषि  (पानी /नहर /कुलोको लागि )" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.nearByHouseCount && properties.disasterType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.nearByHouseCount}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "प्रकोप प्रकार" : "Disaster Type"}:
          </b>{" "}
          {properties.disasterType.map(value => {
            return value === 'flood' ? "बाढी, " : value === 'kataan' ? "कटान, " : value === 'fire' ? "आगलागी, " : value === 'animal_kill' ? "जनावर आतंक, " : value === 'landslide' ? "पहिरो, " : value === 'hawahuri' ? "हावाहुरी, " : value === 'daldal' ? "दलदल, " : "अन्य";
          })}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.organizationName) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>{selectedLanguage === "nepali" ? "ठेगाना" : "Address"}</b>{" "}
          {properties.address}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "उपश्रेणी" : "subCategory"}:
          </b>{" "}
          संस्था
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "संस्थाकाे नाम"
              : "Organization Name"}
            :
          </b>{" "}
          {properties.organizationName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "बाटोको नाम" : "Street Name"}
          </b>{" "}
          {properties.streetName}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "व्यवस्थापक सम्पर्क नम्बर"
              : "manager Contact Number"}
          </b>{" "}
          {properties.managerContactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.securityType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "सुरक्षा प्रकार" : "Ward Number"}:
          </b>{" "}
          {properties.securityType === 'police' ? " इलाका प्रहरी कार्यालय" : properties.securityType === 'police_office' ? "प्रहरी चौकी" : properties.securityType === 'temporary_police_office' ? "अस्थाई प्रहरी बिट" : properties.securityType === 'apf' ? "एपीएफ व्यारेक" : properties.securityType === 'army' ? "सैनिक व्यारेक" : properties.securityType === 'traffic' ? "ट्राफिक कार्यालय" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "कार्य क्षेत्र" : "Area Of Work"}
          </b>{" "}
          {properties.areaOfWork}
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "कार्यालय प्रमुखको नाम"
              : "Office Head Name"}
          </b>{" "}
          {properties.officeHeadName}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "Contact Number" : "सम्पर्क नम्बर"}
          </b>{" "}
          {properties.contactNumber}
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.toleName && properties.dailySlaughterCount) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.toleName}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "टोल नाम" : "Tole Name"}:</b>{" "}
          {properties.toleName}
          <br />
          <b>
            {" "}
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b> {selectedLanguage === "nepali" ? "ठेगाना" : "Address"}:</b>
          {properties.address}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.marketDistance) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}:</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "घरमुलीको नाम" : "Owner Name"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "स्वामित्व" : "ownership"}:
          </b>{" "}
          {properties.ownership.map(value => {
            return value === 'private' ? "निजि  / पब्लिक, " : value === 'community' ? "सामुदायिक, " : "अन्य, ";
          })}
          <br />
          <b>{selectedLanguage === "nepali" ? "विवरण" : "Description"}:</b>{" "}
          {properties.description}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "स्रोत व्यक्तिको नाम"
              : "Resource Person Name"}
            :
          </b>{" "}
          {properties.resourcePersonInfo?.name}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "स्रोत व्यक्ति सम्पर्क नम्बर"
              : "Resource Person Contact Number"}
            :
          </b>
          {properties.resourcePersonInfo?.contactNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.networkRange && properties.towerType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.networkRange}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "टावर प्रकार" : "tower Type"}:
          </b>{" "}
          {properties.towerType === 'Ncell' ? "एनसेल" : properties.towerType === 'ntc' ? "नेपाल टेलिकम" : properties.towerType === 'smartcell' ? "स्मार्ट सेल" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "नेटवर्क दायरा" : "network Range"}:
          </b>{" "}
          {properties.networkRange}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else if (properties.name && properties.resourceType) {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>{selectedLanguage === "nepali" ? "नाम" : "Name"}::</b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "विशेषता" : "Characteristic"}:
          </b>{" "}
          {properties.characteristic}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "स्रोत प्रकार" : "Resource Type"}:
          </b>
          {properties.resourceType === 'mining' ? "खानी क्षेत्र" : properties.resourceType === 'waterfall' ? "झरना" : properties.resourceType === 'simsaar' ? "सिमसार" : properties.resourceType === 'cave' ? "गुफा" : properties.resourceType === 'pond' ? "पोखरी" : properties.resourceType === 'lake' ? "ताल" : properties.resourceType === 'main_water_source' ? "मुख्य पानी मुहान" : "अन्य"}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "संरक्षण निकाय र सम्पर्क"
              : "Conservation Body And Contact"}
            :
          </b>
          {properties.conservationBodyAndContact}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "गुगल प्लस कोड"
              : "Google Plus Code"}
            :
          </b>{" "}
          <a
            href={`https://plus.codes/${properties.googlePlusCode}`}
            target="_blank"
          >
            {properties.googlePlusCode}
          </a>
        </div>
      );
    } else {
      const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.photo}`;
      return (
        <div>
          <img
            src={baseUrl}
            alt={properties.name}
            width={300}
            height={200}
            style={{ objectFit: "cover" }}
            onError={(event) => {
              event.target.src = toAbsoluteUrl("/media/image/NoImageFound.jpg");
              event.onerror = null;
            }}
          />
          <br />
          <br />
          <b>
            {selectedLanguage === "nepali" ? "कार्यालयको नाम" : "Office Name"}:
          </b>{" "}
          {properties.name}
          <br />
          <b>
            {selectedLanguage === "nepali" ? "वडा नम्बर" : "Ward Number"}:
          </b>{" "}
          {properties.wardNumber}
          <br />
          <b>
            {selectedLanguage === "nepali"
              ? "संस्थाको प्रकार"
              : "Institution Type"}
            :
          </b>{" "}
          कार्यालय
          <br />
        </div>
      );
    }
  };

  const properties = props.properties;
  console.log("pointerProps", properties);
  const eachCoordinates = props.coordinates;

  var pointerIcon = L.Icon.extend({
    options: {
      iconAnchor: [12, 24],
      iconSize: [20, 25],
    },
  });

  var icon;
  if (properties.name && properties.principalName) {
    if (properties.instituteType === "private") {
      icon = new pointerIcon({
        iconUrl: schoolPrivateIconUrl,
      });
    } else if (properties.instituteType === "community") {
      icon = new pointerIcon({ iconUrl: schoolCommunityIconUrl });
    }
  } else if (
    properties.institutionsType === "gov_office" ||
    properties.institutionsType === "offices" ||
    properties.institutionsType === "palika_related_office"
  ) {
    icon = new pointerIcon({ iconUrl: officeUrl });
  } else if (properties.institutionsType === "industries") {
    icon = new pointerIcon({ iconUrl: industriesUrl });
  } else if (properties.institutionsType === "education") {
    icon = new pointerIcon({ iconUrl: agricultureUrl });
  } else if (properties.institutionsType === "economic") {
    icon = new pointerIcon({ iconUrl: economicUrl });
  } else if (properties.institutionsType === "forest") {
    icon = new pointerIcon({ iconUrl: homestayUrl });
  } else if (properties.institutionsType === "cultural_heritage") {
    icon = new pointerIcon({ iconUrl: workshopUrl });
  } else if (
    properties.institutionsType === "health" ||
    properties.institutionsType === "public_places"
  ) {
    icon = new pointerIcon({ iconUrl: healthUrl });
  } else if (properties.institutionsType === "infrastructure") {
    icon = new pointerIcon({ iconUrl: infrastructureUrl });
  } else {
    icon = new pointerIcon({ iconUrl: iconUrl });
  }

  return (
    <Marker position={[eachCoordinates[1], eachCoordinates[0]]} icon={icon}>
      <Popup>{institutePopUp(properties)}</Popup>
    </Marker>
  );
}
